export enum VehicleDriverEvaluationConfirmStatusType {
  CODE_IS_INVALID = 'CodeIsInvalid',
  CONFIRMED = 'Confirmed',
  WAITING_REPORT = 'WaitingReport',
}
